import {Component, OnInit, OnDestroy} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Standard} from 'app/models/standard.model';
import {Question} from 'app/models/question.model';
import {Answer} from 'app/models/answer.model';
import {MultiQuestions} from 'app/models/multi-questions';
import {AdminService} from 'app/services/admin.service';
import {StandardWriteAction} from 'app/services/standard-write-action';

interface TemporaryQuestions { questions: MultiQuestions; }
const EMPTY_TEXT = '';
const FIRST_ANSWER_NUMBER = 1;
const ANSWER_COUNT = 3;

@Component({
  selector: 'app-add-new-questions',
  templateUrl: './add-new-questions.component.html',
  styleUrls: ['./add-new-questions.component.css']
})
export class AddNewQuestionsComponent implements OnInit, OnDestroy {
  didReload = false;
  standard: Standard;
  tmpStandard: TemporaryQuestions = null;
  writeAction = new StandardWriteAction();
  successInfo = false;
  invalidQuestions = false;
  russianQuestion: Question;
  englishQuestion: Question;
  private sourceStandard: Standard;
  private sourceVersion: number;

  constructor(public activeModal: NgbActiveModal, private adminService: AdminService) {}

  ngOnInit(): void {
    this.russianQuestion = this.emptyQuestion();
    this.englishQuestion = this.emptyQuestion();
  }

  ngOnDestroy(): void { this.writeAction.ngOnDestroy(); }

  private emptyQuestion(): Question {
    const answers = [new Answer(EMPTY_TEXT), new Answer(EMPTY_TEXT), new Answer(EMPTY_TEXT)];
    return new Question(answers, true, EMPTY_TEXT, new Answer(EMPTY_TEXT));
  }

  chekQuestionArr(): boolean {
    const questions = this.tmpStandard ? this.tmpStandard.questions.russian : this.standard && this.standard.russianQuestions;
    return !this.russianQuestion || !(questions || []).some(item => item.questionText === this.russianQuestion.questionText);
  }

  setStandard(standard: Standard): void {
    this.sourceStandard = standard;
    this.sourceVersion = standard.version;
    this.standard = Object.assign({}, standard);
  }

  setTempStandard(standard: TemporaryQuestions): void { this.tmpStandard = standard; }

  addQuestion(): void {
    if (this.writeAction.pending || this.writeAction.requiresReload) { return; }
    this.invalidQuestions = !this.isQuestionsValid() || !this.chekQuestionArr();
    this.successInfo = false;
    if (this.invalidQuestions) { return; }
    const russian = this.setCorrectAnswer(this.russianQuestion);
    const english = this.setCorrectAnswer(this.russianQuestion);
    this.switchAddQuestion(russian, english);
  }

  switchAddQuestion(russian: Question, english: Question): void {
    if (this.tmpStandard) {
      this.tmpStandard.questions.russian.push(russian);
      this.tmpStandard.questions.english.push(english);
      this.acceptQuestionDraft();
      return;
    }
    const questions = new MultiQuestions([russian], [english]);
    this.writeAction.run(this.standard, snapshot => this.adminService.addQuestionToStandard(snapshot, questions), () => {
      if (this.sourceStandard.version !== this.sourceVersion) { this.writeAction.reject(); return; }
      this.sourceStandard.version = this.sourceVersion = this.standard.version;
      this.sourceStandard.russianQuestions.push(russian);
      this.sourceStandard.englishQuestions.push(english);
      this.acceptQuestionDraft();
    });
  }

  private acceptQuestionDraft(): void {
    this.successInfo = true;
    this.ngOnInit();
  }

  reloadStandard(): void {
    this.writeAction.reload(this.standard, this.adminService.getStandard(this.standard.id), standard => {
      this.didReload = true;
      Object.assign(this.sourceStandard, standard);
      this.activeModal.close();
    });
  }

  private setCorrectAnswer(question: Question): Question {
    const answers = question.answers.map(answer => new Answer(answer.answerText));
    const answerIndex = Number(question.rightAnswer.answerText) - FIRST_ANSWER_NUMBER;
    return new Question(answers, question.isTesting, question.questionText, answers[answerIndex]);
  }

  isQuestionsValid(): boolean {
    const question = this.russianQuestion;
    const correct = Number(question.rightAnswer.answerText);
    if (!question.questionText.trim() || !Number.isInteger(correct) || correct < FIRST_ANSWER_NUMBER || correct > ANSWER_COUNT) {
      return false;
    }
    const answers = question.answers.map(answer => answer.answerText);
    return answers.every(answer => !!answer.trim()) && new Set(answers).size === answers.length;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-standard/popups/add-new-questions/add-new-questions.component.ts